import React from "react";
import PropTypes from "prop-types";

import { MicrodataContext } from "config/contexts";

import styles from "./Headline.css";

export default function Headline({ headline }) {
  return (
    <MicrodataContext.Consumer>
      {(microdata) => (
        <h3 className={styles.headline} itemProp={microdata ? "headline" : undefined}>{headline}</h3>
      )}
    </MicrodataContext.Consumer>
  );
}

Headline.propTypes = {
  headline: PropTypes.string.isRequired,
};
